import { useMemo } from 'react'

import { Card, Table } from '@circlefin/components'
import { SimpleTable } from '@shared/components/tables'
import {
  useWalletPaymentMethodQuery,
  LegalEntity,
  Currency,
  useEntityQuery,
} from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { LinkedWalletsTableRow } from './LinkedWalletsTableRow'

import type { WalletPaymentMethod } from '@shared/graphql'

export const LinkedWalletsTable: React.FC = () => {
  const { t } = useTranslation('settings')
  const { data, loading, error, refetch } = useWalletPaymentMethodQuery({
    fetchPolicy: 'cache-and-network',
  })
  const {
    data: entityData,
    loading: entityLoading,
    error: entityError,
  } = useEntityQuery()

  const wallets: WalletPaymentMethod[] = useMemo(
    () =>
      (data?.walletPaymentMethods ?? []).filter(
        (wallet) =>
          (entityData?.entity?.legalEntity === LegalEntity.CIRCLE_FR &&
            wallet.balance.currency === Currency.EURC) ||
          (entityData?.entity?.legalEntity !== LegalEntity.CIRCLE_FR &&
            wallet.balance.currency === Currency.USDC),
      ),
    [data, entityData?.entity?.legalEntity],
  )

  return (
    <div>
      <div
        className="mb-4 text-xl leading-7 text-black-700 font-circular-bold"
        data-testid="linked-wallets-table"
      >
        {t('billing.linkedWallets.title')}
      </div>
      <Card className="overflow-hidden">
        <SimpleTable
          className="-m-px"
          empty={t`billing.linkedWallets.noResults`}
          error={error || entityError}
          loading={loading || entityLoading}
          numLoadingColumns={3}
          numLoadingRows={1}
          retry={refetch}
          size={data?.walletPaymentMethods.length}
          hoverHighlight
        >
          <Table.Body className="m-0">
            {wallets.map((wallet, key) => (
              <LinkedWalletsTableRow key={key} wallet={wallet} />
            ))}
          </Table.Body>
        </SimpleTable>
      </Card>
    </div>
  )
}
